import { matchPath } from 'react-router-dom';
import { UNIT_ROUTES } from './pages/units/registry';

// 新UIを置く場所。staging で旧UIと並べて試すため /test-ui に置いている。
export const V2_BASE = '/test-ui';

/** v2Path('banner') → '/test-ui/banner' */
export const v2Path = (sub: string) => `${V2_BASE}/${sub}`;

// 新UIで作り直した画面（App.tsx の V2_BASE の子と同じ）。ほかは旧画面を枠の中に出す。
const V2_PAGES = /^\/(?:banner|video|products(?:\/\d+)?)?\/?$/;

const sub = (pathname: string) => pathname.slice(V2_BASE.length) || '/';

const matches = (pathname: string) => UNIT_ROUTES.filter((r) => matchPath(`/${r.path}`, sub(pathname)) !== null);

export const isV2Page = (pathname: string) => V2_PAGES.test(sub(pathname)) || matches(pathname).length > 0;

/** 左メニューなしの集中表示で出す画面（経路のデータの layout: 'focus'） */
export const isFocusPage = (pathname: string) => matches(pathname).some((r) => r.layout === 'focus');

/**
 * 画面切り替えの動きの単位。新UIの画面は URL ごと、旧画面は機能ごと
 * （/chat/new → /chat/12 のような機能の中の移動で、旧画面を出し入れして作り直さない）。
 */
export const frameKey = (pathname: string) => {
  if (isV2Page(pathname)) return pathname;
  const parts = sub(pathname).split('/').filter(Boolean);
  return `legacy:${parts.slice(0, parts[0] === 'ads' ? 2 : 1).join('/')}`;
};
